import { Logo } from "@/components/Logo";

export function MadeWithViny({ variant = "dark" }: { variant?: "light" | "dark" }) {
  return (
    <a
      href="/"
      className={`inline-flex items-center gap-2 transition-opacity hover:opacity-70 ${
        variant === "light" ? "text-white/50" : "text-neutral-500"
      }`}
      aria-label="Feito com Viny — ir para o site"
    >
      <span className="font-mono text-[10px] uppercase tracking-[0.22em]">Feito com</span>
      <Logo variant={variant === "light" ? "light" : "dark"} size={13} withLink={false} />
    </a>
  );
}
